import axios from 'axios'
import {getGlobalUserId} from '@/utils'
import Config from '@/config'
import Cookie from 'js-cookie'
// create an axios instance
const service = axios.create({
    baseURL: $config.api.gateway.general, // api 的 base_url
    timeout: 30000, // request timeout
    headers: {
        //'Content-Type': 'application/json; charset=utf-8'
         'Content-Type': 'application/x-www-form-urlencoded'
    }
});
service.url=Config.api.gateway.project;
service.JsonUrl=Config.api.gateway.JsonUrl;
/*service.wxUrl='https://hw-hwyapi.smarket.net.cn';*/
service.wxUrl=Config.api.gateway.general;
service.postStatic = (url, params, config) => {
    const configs = Object.assign({baseURL:$config.api.gateway.JsonUrl},config);
    return new Promise((resolve, reject) => {
        service.post(url, params, configs).then(
            response => {
                resolve(response)
            },
            err => {
                reject(err)
            }
        ).catch(error => {
            reject(error)
        })
    })
}


service.postJson = (url, params, config) => {
    return new Promise((resolve, reject) => {
        service.post(url, params, config).then(
            response => {
                resolve(response)
            },
            err => {
                reject(err)
            }
        ).catch(error => {
            reject(error)
        })
    })
}

service.getJson = (url,config) => {
    return new Promise((resolve, reject) => {
        service.get(url,config).then(
            response => {
                resolve(response)
            },
            err => {
                reject(err)
            }
        ).catch(error => {
            reject(error)
        })
    })
}
// request interceptor
service.interceptors.request.use(
    config => {
        if (config.method === 'post') {
            config.data = config.data || {};
            // config.data.globalUserId = getGlobalUserId();
            // config.data.sess = config.data.session=config.data.sess;
            // config.data.tenantId = Config.tenantId;
            //file 类型
            //config.data = JSON.stringify({...config.data})
        } else {
            config.params = config.params || {};
            // config.params.getGlobalUserId = getGlobalUserId();
        }
        return config
    },
    error => {
        console.log(error);
        Promise.reject(error)
    }
)

// response interceptor
service.interceptors.response.use(
    response => {
        const res = response.data;
        if (res.body.result !== 0) {
            //alert(res.body.desc);
            // 50008:非法的token; 50012:其他客户端登录了;  50014:Token 过期了;
            if (res.code === 50008 || res.code === 50012 || res.code === 50014) {

            }
            return Promise.reject(res.body)
        } else {
            return Promise.resolve(res.body);
        }
    },
    error => {
        console.log('err' + error); // for debug
        return Promise.reject(error)
    }
)

service.getGlobalUserId = () => {
    if (Cookie.get('globalUserId')) {
        return Cookie.get('globalUserId')
    } else {
        let uuid = 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, (c) => {
            let r = Math.random() * 16 | 0, v = c == 'x' ? r : (r & 0x3 | 0x8);
            return v.toString(16);
        });
        uuid = uuid.replace(/-/g, '');
        Cookie.set('globalUserId', uuid);
        return uuid
    }
}
export default service